export function lenisScroll() {
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
  if (isIOS) return;

  if (!window.lenis && typeof Lenis !== "undefined") {

    window.lenis = new Lenis({
      smooth: true,
      smoothTouch: false,
      lerp: 0.18
    });

    function raf(time) {
      window.lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }
}
